module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/161.18a7a106.png";